// File: typescript/apps/front-end/src/main/react/Dialog/GroupBanUserDialogLazy.ts
//
// Lazy delegate for the imperative ban-user dialog opener. GroupBanUserDialog is zod-backed
// (validation/moderation) and is statically reachable from the eager UserButtons chrome, which kept
// `zod` in main_bundle.js on every page. Routing the opener through this thin module loads the heavy
// dialog (and zod) on demand the first time a moderator bans a user. Drop-in replacement for
// `import { showBanUserDialog } from ".../GroupBanUserDialog"`.
// See designs/01-now/2026-06-29-mobile-cwv-field-regression-...-design.md (N1).

import type {Localizer} from "@/main/react/Types";
import {importChunkWithRetryAndReload} from "@/lib/lazyWithRetry";

export function showBanUserDialog(groupPublicId: string, localizer: Localizer, username?: string, onSuccess?: () => void) {
    void importChunkWithRetryAndReload(
        () => import("@/main/react/Dialog/GroupBanUserDialog").then((m) => ({default: m.showBanUserDialog})),
        "group-ban-user-dialog",
    ).then((m) => m.default(groupPublicId, localizer, username, onSuccess));
}
